import StructureControl from './structure-control';
import ProjectsListManager from "../manager/projects-list-manager";

const debug = false
// const debug = "CreateTreeOptions"

class CreateTreeOptions {

    // EVERY ITEM CAN BE DISABLED !!!! - not selectable but show to reflect structure

    constructor(companies, options = {}) {
        this.filterByAccess = !!options.filterByAccess;

        const { MANAGER, USER } = gd.const.companyRole;
        this.companies = companies ? companies :  gd.session.companies.filterByRoles([MANAGER,USER]).map(c=>c.id);
    }

    _filterTreeItems(treeSource, fiterFunction) {
        const source = treeSource ? treeSource : gd.tree;
        const result = [];

        const recursiveCollectChildren = (p,ch)=>{
            ProjectsListManager.getChildProjects(null, p.id, 'name', false, source).map(c=>{
                const { selectable, visible } = fiterFunction(c);

                if(visible) {
                    const children = [];
                    recursiveCollectChildren(c, children);

                    ch.push({
                        project: c,
                        selectable: selectable,
                        children: children
                    });
                }
            });
        };

        this.companies.map(cId=>{
            const projects = [];
            const treeProjects = ProjectsListManager.getChildProjects(cId, null, 'name', this.filterByAccess, source);
            treeProjects.map(p=>{
                const { selectable, visible } = fiterFunction(p);

                if(visible) {
                    const children = [];
                    recursiveCollectChildren(p, children);
                    projects.push({
                        project: p,
                        selectable: selectable,
                        children: children
                    });
                }
            });

            result.push({
                company: source.getCompany(cId),
                projects: projects
            });
        });

        return result;
    }

    /******* TASK *********/

    newTask(accessLevels, treeSource) {
        const allowedParentTypes = StructureControl.newParentOptions("task");

        return this._filterTreeItems(treeSource, (m)=>{

            const bySystemType  = allowedParentTypes.includes(m.systemType)
            const byAccessLevel = !accessLevels || accessLevels.includes(m.access)
            const visible = bySystemType && byAccessLevel

            // THIS IS PATCHED BY VIC MAY 8 2023 smenil visible na true
            // fishka v tom chto esli new task a netu access k parent naprimer read only
            // to ono i children ne pokazivalo ...

            return {
                selectable  : visible,
                visible     : true // visible
            }
        });
    }

    /******* PROJECT *********/

    newProject(projectSystemType, accessLevels, treeSource) {
        const allowedParentTypes = StructureControl.newParentOptions(projectSystemType)

        debug && console.log(debug, 'newProject allowedParentTypes', allowedParentTypes, projectSystemType)

        return this._filterTreeItems(treeSource, (m)=>{
            const bySystemType = allowedParentTypes.includes(m.systemType)
            const byAccessLevel = !accessLevels || accessLevels.includes(m.access)
            const visible = bySystemType && byAccessLevel

            // fix like in method above (newTask)
            // "fishka v tom chto esli new task a netu access k parent naprimer read only
            // to ono i children ne pokazivalo ..."
            return {
                selectable  : visible,
                visible     : true // visible
            }
        })
    }
}

module.exports = CreateTreeOptions